/* SHADOW v7 — dropdown i desktop-menuen og mobilmenu. Alt virker også uden JS via <details>. */
(function () {
  'use strict';
  var body = document.body;
  var header = document.getElementById('nav');

  /* Lyse v7-sektioner markeres, så menuen (shadow-v3.js) skifter til mørk tekst over dem.
     Denne fil indlæses før shadow-v3.js. */
  document.querySelectorAll('.sh7:not(.sh7-news)').forEach(function (el) { el.setAttribute('data-light', ''); });

  function setHeadHeight() {
    if (!header) return;
    var row = header.querySelector('.sh7-nav__row');
    var h = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--sh7-head-h', Math.round(h) + 'px');
    if (row) row.dataset.h = h;
  }
  setHeadHeight();
  window.addEventListener('resize', setHeadHeight, { passive: true });
  window.addEventListener('scroll', setHeadHeight, { passive: true });

  /* Dropdowns: åbn ved hover på enheder med mus, luk ved klik udenfor og Escape */
  var dds = Array.prototype.slice.call(document.querySelectorAll('[data-sh7-dd]'));
  var canHover = window.matchMedia('(hover: hover)').matches;
  dds.forEach(function (dd) {
    var t;
    var sum = dd.querySelector('summary');
    /* Er menuen allerede åbnet med musen, skal et klik ikke lukke den igen */
    if (sum) sum.addEventListener('click', function (e) {
      if (canHover && dd.open && dd.matches(':hover')) e.preventDefault();
    });
    if (canHover) {
      dd.addEventListener('mouseenter', function () { clearTimeout(t); dd.open = true; });
      dd.addEventListener('mouseleave', function () { t = setTimeout(function () { dd.open = false; }, 180); });
    }
    dd.addEventListener('toggle', function () {
      if (dd.open) dds.forEach(function (o) { if (o !== dd) o.open = false; });
    });
    dd.addEventListener('focusout', function (e) {
      if (!dd.contains(e.relatedTarget)) dd.open = false;
    });
  });

  /* Mobilmenu */
  var mnav = document.querySelector('[data-sh7-mnav]');
  if (mnav) {
    mnav.addEventListener('toggle', function () {
      setHeadHeight();
      body.classList.toggle('sh7-menu-open', mnav.open);
    });
    mnav.addEventListener('click', function (e) {
      if (e.target.closest('a')) mnav.open = false;
    });
    window.matchMedia('(min-width: 901px)').addEventListener('change', function (e) {
      if (e.matches) mnav.open = false;
    });
  }

  document.addEventListener('click', function (e) {
    dds.forEach(function (dd) { if (dd.open && !dd.contains(e.target)) dd.open = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    dds.forEach(function (dd) {
      if (dd.open) { dd.open = false; var s = dd.querySelector('summary'); if (s) s.focus(); }
    });
    if (mnav && mnav.open) { mnav.open = false; var ms = mnav.querySelector('summary'); if (ms) ms.focus(); }
  });

  /* Kurv-linket i mobilmenuen åbner kurv-skuffen og lukker menuen */
  document.addEventListener('shopify:section:load', setHeadHeight);
})();
